import EfiModel from "../../components/allModels/efiModel";
import AttachmentCard from "../../components/home/attachments/attachmentCard";
import Attachments from "../../components/home/attachments/attachments";
import AttachmentImg1 from "../../assets/images/AttachmentsImg/attachments-1.jpg";
import AttachmentImg2 from "../../assets/images/AttachmentsImg/attachments-2.jpg";
import AttachmentImg3 from "../../assets/images/AttachmentsImg/attachments-3.jpg";
import AttachmentImg4 from "../../assets/images/AttachmentsImg/attachments-4.jpg";
import AttachmentImg5 from "../../assets/images/AttachmentsImg/attachments-5.png";
import AttachmentImg6 from "../../assets/images/AttachmentsImg/attachments-6.png";
import AttachmentImg7 from "../../assets/images/AttachmentsImg/attachments-7.png";
import AttachmentImg8 from "../../assets/images/AttachmentsImg/attachments-8.png";
import AttachmentImg9 from "../../assets/images/AttachmentsImg/attachments-9.jpg";
import AttachmentImg10 from "../../assets/images/AttachmentsImg/attachments-10.jpg";
import AttachmentImg11 from "../../assets/images/AttachmentsImg/attachments-11.jpg";
import AttachmentImg12 from "../../assets/images/AttachmentsImg/attachments-12.jpg";
import AttachmentImg13 from "../../assets/images/AttachmentsImg/attachments-13.png";
import AttachmentImg14 from "../../assets/images/AttachmentsImg/attachments-14.jpg";
import AttachmentImg15 from "../../assets/images/AttachmentsImg/attachments-15.png";
import AttachmentImg16 from "../../assets/images/AttachmentsImg/attachments-16.png";
import AttachmentImg17 from "../../assets/images/AttachmentsImg/attachments-17.png";

const Attachment = () => {
  const modelInfo = {
    title: (
      <div className="flex font-[Rockwell] 2xl:text-[40px] xl:text-[35px] lg:text-[30px] md:text-[25px] sm:text-[20px] text-[17px] font-extrabold ">
        <span className="lg:border-b-[5px] sm:border-b-[4px] border-b-[2px] border-[#5B792E]">ATTACH</span>
        MENTS & ADD-ONS
      </div>
    ),
    dec: `Tuatara offers a range of attachments and add-ons designed to enhance both comfort and functionality for any job. From glass windscreens with wipers, rear enclosures, and full-length doors with sliding windows, to air conditioning systems and stainless steel cages, these features ensure your vehicle is equipped to handle any environment. Whether you need added protection, climate control, or custom upgrades, these accessories allow you to tailor your utility vehicle to meet the demands of your work or adventure.`,
  };

  const AttachmentList = [
    {
      img: AttachmentImg1,
      title: "GLASS WINDSHIELD + WIPER + WASH BOTTLE",
      subTitle: "Provides enhanced visibility and protection from the elements, ensuring a clear view in any weather.",
      modelNo: "GW-M012022",
      Suitable: "all models",
    },
    {
      img: AttachmentImg2,
      title: "REAR ENCLOSURE + GLASS WINDOW",
      subTitle: "Provides added protection and visibility, making it a versatile upgrade for all Tuatara models.",
      modelNo: "PRE-M012022",
      Suitable: "all models",
    },
    {
      img: AttachmentImg3,
      title: "FULL LENGTH PC DOORS + SLIDING WINDOWS  ",
      subTitle:
        "Provide durable, weather-resistant protection and ventilation, ensuring comfort and safety in any terrain.",
      modelNo: "FD-M012023",
      Suitable: "all models",
    },
    {
      img: AttachmentImg4,
      title: "FULL LENGTH UPGRADED DOORS + TWO GLASS PANELS + SLIDING WINDOWS",
      subTitle:
        "Provides enhanced durability and ventilation, protection from the elements while maintaining visibility and airflow.",
      modelNo: "FD-M012024(N)",
      Suitable: "all models",
    },
    {
      img: AttachmentImg5,
      title: "PC HALF DOORS",
      subTitle: "Durable design that enhances comfort while maintaining an open feel.",
      modelNo: "HD-M012023",
      Suitable: "all models",
    },
    {
      img: AttachmentImg6,
      title: "AIR CONDITIONER + ACCESSORIES (1 SET)",
      subTitle:
        "Provides efficient cool and warm air for ultimate comfort, ensuring a pleasant environment during your rides.",
      modelNo: "EAC-SC01",
      Suitable: "1500E-4, SC2000E, DC2500E",
    },
    {
      img: AttachmentImg7,
      title: "AIR CONDITIONER + ACCESSORIES (2 SETS)",
      subTitle:
        "Provides efficient cool and warm air for ultimate comfort, ensuring a pleasant environment during your rides. (2 Sets for Double Cab Vehicle)",
      modelNo: "EAC-DC02",
      Suitable: "DC2500E",
    },
    {
      img: AttachmentImg8,
      title: "ACRYLIC FOLDABLE WINDSCREEN + FASTENING BRACKETS",
      subTitle: "Provides flexible protection from the elements to enhance comfort and visibility.",
      modelNo: "AFW-02",
      Suitable: "all models",
    },
    {
      img: AttachmentImg9,
      title: "BENCH SEAT + REAR DECK MOUNTING",
      subTitle:
        "Provides additional seating at the back of the cabin, making it ideal for hunting trips and enhancing passenger capacity.",
      modelNo: "BS-M012022",
      Suitable: "all models",
    },
    {
      img: AttachmentImg10,
      title: "ORCHARDIZED KIT",
      subTitle:
        "Removes the roof and steel roll cage, allowing for easy navigation through orchards and low-clearance areas.",
      modelNo: "ORD-M2024N",
      Suitable: "all models",
    },
    {
      img: AttachmentImg11,
      title: "STAINLESS STEEL CAGE (1000EFI)",
      subTitle:
        "Provides robust protection and security for the cargo bed, ensuring your equipment and supplies are safe and secure during transport.",
      modelNo: "SLC-P1000",
      Suitable: "1000EFI models",
    },
    {
      img: AttachmentImg12,
      title: "STAINLESS STEEL CAGE (1500E)",
      subTitle:
        "Provides robust protection and security for the cargo bed, ensuring your equipment and supplies are safe and secure during transport.",
      modelNo: "SLC-E1500",
      Suitable: "1500E models",
    },
    {
      img: AttachmentImg13,
      title: "TUATARA TRAILER (load capacity 1763LBS)",
      subTitle:
        "Provides a robust loading capacity of 1,763 lbs, is designed to effortlessly transport your gear and equipment.",
      modelNo: "TU-T01",
      Suitable: "all models",
    },
    {
      img: AttachmentImg14,
      title: "MIDDLE SEAT CONSOLE",
      subTitle:
        "Replaces the standard middle seat with a functional center console, providing convenient storage and enhanced comfort for passengers.",
      modelNo: "##-###",
      Suitable: "all models",
    },
    {
      img: AttachmentImg15,
      title: "CUSTOM PAINT",
      subTitle:
        "Allows for custom paint color and personalization, available exclusively for large fleet vehicle purchases.",
      modelNo: "##-###",
      Suitable: "commercial fleet vehicles",
    },
    {
      img: AttachmentImg16,
      title: "FIRE EXTINGUISHER",
      subTitle:
        "provides essential safety and peace of mind, ensuring you’re prepared for emergencies on any job or adventure.",
      modelNo: "##-###",
      Suitable: "all models",
    },
    {
      img: AttachmentImg17,
      title: "RAPTOR BED LINER",
      subTitle:
        "Provides superior resistance against abrasions, rust, and corrosion while offering a rugged, non-slip surface for all your hauling needs.",
      modelNo: "##-###",
      Suitable: "all models",
    },
  ];
  return (
    <>
      <Attachments NotShowBtn={true} />

      <EfiModel modelInfo={modelInfo} />

      <div className="bg-[#fff]">
        <div className="custom-container">
          {AttachmentList?.map((item) => {
            return <AttachmentCard item={item} />;
          })}
        </div>
      </div>
    </>
  );
};
export default Attachment;
